type ImportResponse = {
  count?: number;
  data?: unknown[];
  message?: string;
  errors?: Array<{ row: number; message: string }>;
};

type RunExcelImportArgs = {
  partnerId?: string;
  file: File | null;
  emptyFileMessage: string;
  itemLabel: string;
  importFn: (partnerId: string, file: File) => Promise<ImportResponse>;
  setBusy: (busy: boolean) => void;
  setMessage: (message: string) => void;
  setErrors: (errors: Array<{ row: number; message: string }>) => void;
  clearFile: () => void;
  showToast: (message: string, type?: "success" | "error") => void;
  onSuccess: () => void | Promise<void>;
};

export async function runExcelImport({
  partnerId,
  file,
  emptyFileMessage,
  itemLabel,
  importFn,
  setBusy,
  setMessage,
  setErrors,
  clearFile,
  showToast,
  onSuccess,
}: RunExcelImportArgs): Promise<void> {
  if (!partnerId || !file) {
    showToast(emptyFileMessage, "error");
    return;
  }

  try {
    setBusy(true);
    setMessage("");
    setErrors([]);
    const response = await importFn(partnerId, file);
    const count = response.count ?? response.data?.length ?? 0;
    setMessage(response.message || `Import thành công ${count} ${itemLabel}`);
    if (response.errors?.length) {
      setErrors(response.errors);
    }
    clearFile();
    showToast(response.message || `Đã import ${count} ${itemLabel}`);
    await onSuccess();
  } catch (err: any) {
    showToast(err.message || `Import ${itemLabel} thất bại`, "error");
    if (err.errors && Array.isArray(err.errors)) {
      setErrors(err.errors);
    }
  } finally {
    setBusy(false);
  }
}
